module.exports = __webpack_public_path__ + "media/images/logo-5c16ef802a912cfc12b4119bedd4cc12.svg";